import { __rest } from "tslib";
import React from 'react';
import MenuItem from './menu-item';
import Icon from '../icon';
import Text from '../text';
import { cn, isString } from '~/utils';
import { checkbox, item } from './menu-checkbox-item.css';
const MENU_CHECKBOX_ITEM_NAME = 'vulcanui-menu-checkbox-item';
function MenuCheckboxItem(props) {
    const { checked, children, color, className, as } = props, restProps = __rest(props, ["checked", "children", "color", "className", "as"]);
    return (React.createElement(MenuItem, Object.assign({ as: as, startContent: React.createElement(Icon, { name: checked ? 'square-check' : 'square', type: checked ? 'solid' : 'regular', className: checkbox({ color, checked }) }), title: isString(children) ? children : undefined, "aria-checked": checked, className: cn(className, item({ checked })) }, restProps),
        React.createElement(Text, { as: "span", maxLines: 1, color: "inherit" }, children)));
}
MenuCheckboxItem.displayName = 'Menu.CheckboxItem';
MenuCheckboxItem.toString = () => `.${MENU_CHECKBOX_ITEM_NAME}`;
export default MenuCheckboxItem;
//# sourceMappingURL=menu-checkbox-item.js.map